/* eslint-disable no-undef */
import $ from "jquery";
import __ajax from "../../utils/submit-form/__ajax";
import { setTimeout } from "core-js";
import {
    validationRequired,
    validationRepeat,
} from "../../utils/util-validationForm";

const inkomendeVerzoeken = () => {
    const init = () => {
        counterNotif();
        LiveProduct();
        SetSoldProduct();
        RejectProduct();
        AcceptProduct();
        InspectProduct();
    };

    const counterNotif = () => {
        const el = {
            headerCounter: ".js-notification-count",
            menuCounter:
                ".woocommerce-MyAccount-navigation-link--inkomende-verzoeken",
            inputCount: ".AccountPage__Wrapper__Nav #count-incoming-request",
            parentClass: ".AccountPage",
        };

        if ($(el.parentClass).length === 0) return;

        let numberOfReq = 0;

        $(window).on("load", function () {
            numberOfReq = $(el.inputCount).val();
            $(el.headerCounter).text(numberOfReq);
            $(el.menuCounter)
                .find("a")
                .after(
                    `<span class="IncomingRequestCount">${numberOfReq}</span>`,
                );
        });
    };

    const RejectProduct = () => {
        $(document).on("click", "#js_btn_reject_product", function () {
            const validationRepeat_ = validationRepeat("#reason_reject");
            const validationRequired_ = validationRequired($(this));

            if (!validationRequired_ || !validationRepeat_) return;
            $("body").addClass("mi-loading");
            const data = {
                action: themeObj.specialist.action.reject,
                nonce: themeObj.specialist.nonce,
                product_id: $("#id").val(),
                message: $("#reason_reject").val(),
            };

            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: data,
            })
                .done(() => {
                    $("body").removeClass("mi-loading");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                })
                .fail((response) => {
                    $("body").removeClass("mi-loading");
                    console.error(response);
                });
        });
    };

    const AcceptProduct = () => {
        $(document).on("click", "#js_btn_accept_product", function () {
            $("body").addClass("mi-loading");
            const idPopupSuccess = $(this).data("for");
            const data = {
                action: themeObj.specialist.action.accept,
                nonce: themeObj.specialist.nonce,
                product_id: $("#id").val(),
                price: $("#input-price").val(),
            };

            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: data,
            })
                .done((response) => {
                    $("body").removeClass("mi-loading");
                    $(idPopupSuccess).addClass("active");
                    console.warn(response);
                })
                .fail((response) => {
                    $("body").removeClass("mi-loading");
                    console.error(response);
                });
        });
    };

    const InspectProduct = () => {
        $(document).on("click", ".js-change_status_product", function () {
            __ajax($(this), {
                product_id: $(this).data("product_id"),
            })
                .then(() => window.location.reload())
                .catch((err) => console.error(err));
        });
    };

    const LiveProduct = () => {
        $(document).on("click", ".js-levend-product-card-select", function () {
            $("#js-live-product-id").val($(this).data("id"));
        });

        $(document).on("click", ".js-publish-product-btn", function () {
            $("body").addClass("mi-loading");
            const data = {
                action: themeObj.specialist.action.accept,
                nonce: themeObj.specialist.nonce,
                product_id: $("#js-live-product-id").val(),
            };

            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: data,
            })
                .done(() => {
                    window.location.reload();
                    $("body").removeClass("mi-loading");
                })
                .fail((response) => {
                    $("body").removeClass("mi-loading");
                    console.error(response);
                });
        });
    };

    const SetSoldProduct = () => {
        $(document).on("click", ".js-levend-product-card-select", function () {
            $("#js-live-product-id").val($(this).data("id"));
        });

        $(document).on("click", ".js-sold-product-btn", function () {
            $("body").addClass("mi-loading");

            const data = {
                action: themeObj.specialist.action.sold,
                nonce: themeObj.specialist.nonce,
                product_id: $("#js-live-product-id").val(),
            };

            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: data,
            })
                .done(() => {
                    $("body").removeClass("mi-loading");
                    window.location.reload();
                })
                .fail((response) => {
                    $("body").removeClass("mi-loading");
                    console.error(response);
                });
        });
    };

    init();
};

try {
    inkomendeVerzoeken();
} catch (error) {
    console.error("inkomendeVerzoeken: ", error);
}
